export enum ReturnStatus {
    New,
    InProcessing,
    Closed
}